import { connect } from 'react-redux';
import UserInfo from './UserInfo';
import { getUser, updateInfoLoading, updatePicLoading, getError } from '../../../store/selectors/user.selector';
import { updateProfileData, updateProfilePicture, getRoles } from '../../../store/actions/user.actions';

const mapDispatchToProps = { updateProfileData, updateProfilePicture, getRoles };

const mapStateToProps = (state) => { 
    let user = getUser(state);
    const infoLoading = updateInfoLoading(state);
    const pictureLoading = updatePicLoading(state);
    const error = getError(state);
    
    if (Object.keys(user).length === 0) {
        user = JSON.parse(localStorage.getItem('user'));
    }

    return { user, error, infoLoading, pictureLoading };
 };

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);

    